const formViewer = () => {
  $('.btn-view-form').on('click', function(e) {
    $('.form-modal').modal();
    let url = $(e.target).parents('.table-row').data(url);
    $.getScript(url);
  });
}

export { formViewer }
